import { renderFiles as renderFilesInternal, setContainerSelector, getContainerSelector } from './render.js';
import { initAllEvents } from './events.js';
import { updateResultsCount, updateSearchProgress, forceHighlightNameSearchCount } from './results.js';
import { attachEscapeHandler } from './escape-handler.js';
import { SEARCH_LIMIT } from '../../../modules/files/file-list.utils.js';

// Initialize escape handler on module load
attachEscapeHandler();

export async function renderFiles(files, append = false) {
	const result = await renderFilesInternal(files, append);
	
	if (result && result.container) {
		const { files: renderedFiles, startIndex, append: isAppend, container } = result;
		initAllEvents(container, renderedFiles, startIndex, isAppend);
		if (!isAppend) {
			const hasMore = renderedFiles.length === SEARCH_LIMIT;
			updateResultsCount(renderedFiles.length, hasMore);
		}
	} else {
		console.warn('[file-list-dom] ⚠️ renderFiles completed but no result or container', {
			hasResult: !!result,
			hasContainer: !!(result && result.container)
		});
	}
}

// Export public API
export { setContainerSelector };
export { updateSearchProgress };
export { updateResultsCount };
export { forceHighlightNameSearchCount };

